import { readDisplayAddSearch } from '../../lib/search-display-intent.ts'
import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { DisplaysScreen } from './-components/displays-screen.tsx'

/**
 * The Displays page.
 *
 * Engineering edits the playlist each office TV rotates through. The TV
 * itself reads `GET /display-playlist`, which this page does not call.
 */
export const Route = createFileRoute('/platform/displays')({
  validateSearch: readDisplayAddSearch,
  component: DisplaysPage
})

function DisplaysPage(): JSX.Element {
  const navigate = Route.useNavigate()
  const { addPage } = Route.useSearch()
  return (
    <DisplaysScreen
      addPage={addPage}
      navigate={path => {
        void navigate({ href: path })
      }}
    />
  )
}
